enum CDN {
    None,
    Fallback,
    Akamai,
    CDNetworks,
    Cloudfront,
    Limelight
}

namespace CDN {
    export function abbreviation(cdn: CDN) {
        switch (cdn) {
            case CDN.None: return "";
            case CDN.Fallback: return "fb";
            case CDN.Akamai: return "ak";
            case CDN.CDNetworks: return "cd";
            case CDN.Cloudfront: return "cl";
            case CDN.Limelight: return "ll";
        }
    }
}

export { CDN };
